import { makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useContext, useEffect, useState } from 'react';
import { OfficeContext } from '../../../config/Context';
import { planEatApi } from '../../../planEatApi/PlanEatApi';
import { ICompanyContent } from '../../../planEatApi/PlanEatFacade';
import { Onboarding } from '../../Onboarding/Onboarding';

const useStyles = makeStyles((theme: any) => ({
    container: {
        background: "white",
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        minHeight: 400,
        padding: 30,
        width: "100%",
    },
    skeleton: {
        display: "flex",
        flexDirection: "column",
        rowGap: 15
    }
}));

interface Props {
    
}

export const AdminOnboarding: React.FC<Props> = ({}) => {
    const classes = useStyles()
    const [company, setCompany] = useState<ICompanyContent>();
    const officeContext = useContext(OfficeContext);  

    useEffect(() => {
        if(officeContext?.office){
            planEatApi.getCompanies()
            .then((response) => {
                if(response.data.length > 0){
                    const selectedCompany = response.data.find(item => item.content.id == officeContext.office?.content.companyId)
                    if(selectedCompany){
                        setCompany(selectedCompany.content)
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            })
        }
    },[officeContext?.office])
    
    return (
        <div className={classes.container}>
            {
                company ?
                <Onboarding companyContent={company} />
                :
                <div className={classes.skeleton}>
                    <Skeleton variant="rect" width={"100%"} height={300} />
                    <Skeleton variant="rect" width={"100%"} height={300} />
                    <Skeleton variant="rect" width={"100%"} height={50} />
                </div>
            }
        </div>
    )
}